<script lang="ts">
import type { VariantProps } from 'tailwind-variants';
import { tv } from 'tailwind-variants';

export const pageContent = tv({
	variants: {
		width: {
			'narrow-contained': 'mx-auto w-page',
			'wide-contained': 'mx-auto w-container',
			'full-bleed': 'w-full',
		},
		gutters: {
			page: 'px-page',
			none: '',
		},
		verticalPadding: {
			page: 'py-8',
			none: '',
		},
		fill: {
			true: 'flex h-full min-h-0 flex-1 overflow-hidden',
			false: '',
		},
	},
	defaultVariants: {
		width: 'narrow-contained',
	},
});

export type PageContentVariants = VariantProps<typeof pageContent>;

export interface PageContentProps {
	width?: PageContentVariants['width'];
	gutters?: PageContentVariants['gutters'];
	verticalPadding?: PageContentVariants['verticalPadding'];
	fill?: boolean;
}
</script>

<script setup lang="ts">
import { computed } from 'vue';

const { width = 'narrow-contained', gutters, verticalPadding, fill } = defineProps<PageContentProps>();

const className = computed(() => {
	const spacing = width === 'full-bleed' ? 'none' : 'page';

	return pageContent({
		width,
		gutters: gutters ?? spacing,
		verticalPadding: verticalPadding ?? spacing,
		fill,
	});
});
</script>

<template>
	<div :class="className">
		<slot />
	</div>
</template>
